import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { HttpHelper } from '../helpers/http';
import { ForgotPasswordRequest } from '../models/authorization/forgot-password.model';
import { ConsumeTokenResponse } from '../models/authorization/consume-token-response.model';

@Injectable({
	providedIn: 'root'
})
export class ForgotPasswordService {
	private forgotPasswordEndpoint: string; 
	private consumeEndpoint: string;	

	constructor(
		private http: HttpClient,
		private environmentService: EnvironmentService,
		private httpHelper: HttpHelper
	) {
		this.forgotPasswordEndpoint = this.environmentService.getBaseUrl() + "/api/authentication/forgot-password";
		this.consumeEndpoint = this.environmentService.getBaseUrl() + "/api/authentication/consume";
	}

	public initiateForgotPassword(email: string): Observable<any> {
		return this.http.post(
			this.forgotPasswordEndpoint,
			JSON.stringify(new ForgotPasswordRequest(email)),
			this.httpHelper.SetRequiredAwsHttpPostHeaders())
		.pipe(map(res => { 
			return res; 
		}));;
	}

	public consume(token: string): Observable<ConsumeTokenResponse> {
		return this.http.post<ConsumeTokenResponse>(
			this.consumeEndpoint + "?token=" + token,
			null,
			this.httpHelper.SetRequiredAwsHttpPostHeaders())
		.pipe(map(res => {
			return res;
		}));;
	}
}
